import DangerousWithSanitization from '@base/DangerousWithSanitization';
import { ANSWERING_INSTRUCTIONS } from '../../constants';
import { Section, StyledH4, StyledLi, StyledOl, StyledP1 } from './Common';

const renderInfo = (info, index) => {
  if (!index) {
    return (
      <>
        <StyledP1>{info.text}</StyledP1>
        <StyledOl>
          {info.subInstructions.map((subInfo, subIndex) => {
            return (
              // eslint-disable-next-line react/no-array-index-key
              <StyledLi $listStyle="lower-alpha" key={subIndex}>
                <DangerousWithSanitization as={StyledP1} html={subInfo.text} />
              </StyledLi>
            );
          })}
        </StyledOl>
      </>
    );
  }
  return <StyledP1>{info.text}</StyledP1>;
};

const Answering = () => {
  return (
    <Section>
      <StyledH4>Answering a question</StyledH4>
      <StyledOl>
        {ANSWERING_INSTRUCTIONS.map((info, index) => {
          return (
            // eslint-disable-next-line react/no-array-index-key
            <StyledLi key={index}>{renderInfo(info, index)}</StyledLi>
          );
        })}
      </StyledOl>
    </Section>
  );
};

export default Answering;
